import blankAction from '../assets/images/bbBlankAction.png'
import getCombatantSlots from './getCombatantSlots'

export default async function getCombatantPreviousRoundActionImage(
  combatant,
  round,
  extraActionSlot = null,
) {
  console.log('------------------------------------------------')
  console.log('IN getCombatantPreviousRoundActionImage = ', {
    name: combatant?.name,
    slug: combatant?.slug,
    round,
  })

  if (!combatant?.slug || !Number.isFinite(round) || round <= 1) {
    console.log('getCombatantPreviousRoundActionImage early return due to invalid combatant/round')
    return ''
  }

  const slots = await getCombatantSlots(combatant.slug)
  const previousRound = round - 1
  const actions = Array.isArray(slots?.actions) ? slots.actions : []
  const blockedExtraSlot = Number(extraActionSlot)
  const hasBlockedExtraSlot = Number.isFinite(blockedExtraSlot) && blockedExtraSlot > 0

  const previousRoundAction = actions
    .filter(
      (action) =>
        action?.round === previousRound &&
        Number.isFinite(action?.number) &&
        (!hasBlockedExtraSlot || action.number !== blockedExtraSlot) &&
        action?.action_name !== 'pending' &&
        action?.action_name !== 'blank',
    )
    .sort((left, right) => right.number - left.number)[0]

  console.log('getCombatantPreviousRoundActionImage action summary = ', {
    name: combatant?.name,
    previousRound,
    blockedExtraSlot: hasBlockedExtraSlot ? blockedExtraSlot : null,
    actionCount: actions.length,
    previousRoundActionCount: actions.filter((action) => action?.round === previousRound).length,
    selectedAction: previousRoundAction
      ? {
          action_name: previousRoundAction.action_name,
          number: previousRoundAction.number,
          action_image: previousRoundAction.action_image,
        }
      : null,
    fallbackImage: previousRoundAction?.action_image || blankAction,
  })

  return previousRoundAction?.action_image || blankAction
}
